import { render, staticRenderFns } from "./GenericView.vue?vue&type=template&id=61072fac&scoped=true"
import script from "./GenericView.vue?vue&type=script&lang=js"
export * from "./GenericView.vue?vue&type=script&lang=js"
import style0 from "./GenericView.vue?vue&type=style&index=0&id=61072fac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61072fac",
  null
  
)

export default component.exports